import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { EditProductComponent } from '@teem/product-module/modals/edit-product/edit-product.component';
import { SharedDataService } from '@teem/services/shared-data.service';
import { ProductService } from '@teem/services/product.service';
import { LoaderService } from '@teem/services/loader.service';
import { Product } from '@teem/models/product';

@Component({
  selector: 'product-grid',
  templateUrl: './product-grid.component.html',
  styleUrls: ['./product-grid.component.scss']
})
export class ProductGridComponent implements OnInit {
  @Output() onEditProduct: EventEmitter<any> = new EventEmitter();
  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Output() onStatusChange: EventEmitter<any> = new EventEmitter();
  @Input() paginator;
  @Input() isProductSelected;
  @Input('myProducts') myProducts:Product[];
  @Output() onSelect: EventEmitter<any> = new EventEmitter();
  locale: string = 'en';
  product: any = {};
  basicInfo:any;
  selectKey: string = 'uuid';
  selected: Array<any> = [];
  selectedRows: Array<any> = [];
  showMenu: boolean = false;

  constructor(
    private productService: ProductService,
    private loaderService: LoaderService,
    private sharedDataService: SharedDataService ,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.locale = (window as any).LOCALE;
  	this.basicInfo = (window as any).userInfo;
    this.sharedDataService.asObservable().subscribe((data) => {
      if(data && data.userInfo) {
        this.basicInfo = data.userInfo;
      }
    })
  }

  ngOnChanges() {
    this.reset();
  }

  reset() {
    this.selected = [];
    this.selectedRows = [];
    this.showMenu = false;
  }

  toggleSelect(id: any, row: any) {
    let index = this.selected.indexOf(id);
    if (index == -1) {
      this.selected.push(id);
      this.selectedRows[row[this.selectKey]] = row;
      // this.onSelect.emit(Object.values(this.selectedRows))
      this.onSelect.emit(Object.values(this.selected))
    } else {
      this.selected.splice(index, 1);
      delete this.selectedRows[row[this.selectKey]];
      // this.onSelect.emit(Object.values(this.selectedRows));
      this.onSelect.emit(Object.values(this.selected));
      if (this.selected.length == 0) {
        this.showMenu = false;
      }
    }
  }

  editProduct(product: any) {
    this.loaderService.startLoading();
    this.productService.get(product.uuid).subscribe(product => {
      this.product = product;
      this.openEditProductModal();
      this.loaderService.stopLoading();
    }, err => {
      this.loaderService.stopLoading();
    })
  }

  openEditProductModal() {
    let modalRef = this.modalService.open(EditProductComponent);
    modalRef.componentInstance.productInfo = this.product;

    const parentElement = modalRef.componentInstance.el.nativeElement.parentNode.parentNode.parentElement;
    parentElement.id = "add-product-service";
    parentElement.classList.add( "new-product-service");

    modalRef.result.then(
      onfulfilled => {
        this.onEditProduct.emit();
      },
      onrejected => {

      }
    );
  }

  deleteProduct(product) {
    this.onDelete.emit(product);
  }

  showHideProduct(product: any, key: string, type: 'status-update' | 'stock-status') {
		this.productService.action({ 'do': type, 'ids': [product.uuid] }).subscribe(response => {
      console.log(response);
    }, err => {
      console.error(err);
    });

		product[key] = !product[key];
	}

  // showHideProduct(product: any) {
  //   this.onStatusChange.emit(product);
  //   // this.loaderService.startLoading();
  //   // this.productService.action({'do': 'status-update', 'ids': [product.uuid]}).subscribe(product => {
  //   //   this.product = product;
  //   //   this.loaderService.stopLoading();
  //   // }, err => {
  //   //   this.loaderService.stopLoading();
  //   // })
  // }

  showHideActions(index) {
    // console.log('index');
    // console.log(index);
    // $('.options-menu').addClass('d-none');
    // $('.options-menu-'+ index).removeClass('d-none');
    const $target = $('.options-menu-' + index);

    // If the clicked menu is already visible, hide it
    if (!$target.hasClass('d-none')) {
      $target.addClass('d-none');
    } else {
      // Hide all, then show the selected one
      $('.options-menu').addClass('d-none');
      $target.removeClass('d-none');
    }
  }
}
